export const dashboardsFeatures = {
    summary: {
        name: 'Dashboards',
        description: 'Combine insights into shareable dashboards',
        url: '/dashboards',
        docsUrl: '/docs/product-analytics/dashboards',
    },
    features: {
        annotations: {
            name: 'Annotations',
            description: 'Add notes to timelines to mark important events',
        },
        custom_dashboards: {
            name: 'Custom dashboards',
            description: 'Build a custom dashboard of your own or use a template',
        },
        dashboard_level_permissions: {
            name: 'Dashboard-level permissions',
            description: 'Set permissions for individual dashboards',
        },
        dashboard_tags: {
            name: 'Dashboard and insight tags',
            description: 'Organize dashboards and insights with custom tags',
        },
        embed_dashboards: {
            name: 'Embed dashboards anywhere',
            description: 'Embed dashboards into external websites or applications',
        },
        pinned_dashboards: {
            name: 'Pinned dashboards',
            description: 'Pin frequently used dashboards for quick access',
        },
        private_insights: {
            name: 'Private insights',
            description: 'Create insights visible only to you',
        },
        project_level_permissions: {
            name: 'Project-level permissions',
            description: 'Manage permissions across entire projects',
        },
        share_dashboards_externally: {
            name: 'Share dashboards externally',
            description: 'Create shareable links for stakeholders outside your organization',
        },
        subscribe_to_dashboards: {
            name: 'Subscribe to dashboards',
            description: 'Receive email or Slack notifications when dashboards update',
        },
        user_level_permissions: {
            name: 'User-level permissions',
            description: 'Control access at the individual user level',
        },
    },
}
